import {
    ADDITIONAL_EMAILS_RESOURCE_NAME,
    MAX_CHATS_RESOURCE_NAME,
    TELEGRAM_CHATS_RESOURCE_NAME,
} from 'shared/config/model/urls';

import {DefaultValues} from 'react-hook-form';

import {normalizeTags} from 'entities/monitor';
import {idsToIri, normalizeIds} from 'shared/api/iriHelper';

import CreateServerType from '../model/Server/CreateServerType';
import IServerOutput from '../model/Server/IServer';

export const getServerFormDefaults = (item?: IServerOutput): DefaultValues<CreateServerType> => ({
    name: item?.name,
    notify_by_email: item?.notify_by_email ?? false,
    telegram_chats: normalizeIds(item?.telegram_chats),
    max_chats: normalizeIds(item?.max_chats),
    additional_emails: normalizeIds(item?.additional_emails),
    tags: item?.tags?.map(tag => tag.label) ?? [],
});

export const buildServerPayload = (formData: CreateServerType): CreateServerType => ({
    ...formData,
    telegram_chats: idsToIri(formData.telegram_chats, TELEGRAM_CHATS_RESOURCE_NAME),
    max_chats: idsToIri(formData.max_chats, MAX_CHATS_RESOURCE_NAME),
    additional_emails: idsToIri(formData.additional_emails, ADDITIONAL_EMAILS_RESOURCE_NAME),
    tags: formData.tags ? normalizeTags(formData.tags) : [],
});
